import { InlineStack } from '@shopify/polaris';
import { useLookupStore } from '../../context/useStore';
import { countryCodeToFlag } from './functions.jsx';

export const CountryWithFlag = ({ countryId }) => {
  const countries = useLookupStore((state) => state.countries);
  const iso = countries.find((c) => c.LandId === countryId)?.ISO2;

  return (
    <InlineStack blockAlign="center" gap="100" wrap={false}>
      {iso ? (
        <span role="img" aria-label={iso}>
          {countryCodeToFlag(iso)}
        </span>
      ) : null}
      {countries.find((country) => parseInt(country.LandId) === parseInt(countryId))?.Land || ''}
    </InlineStack>
  );
};
